import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import React, { useEffect, useRef, useState } from "react"
import secureLocalStorage from "react-secure-storage"
import { Button, Card, CardBody, Col, Row } from "reactstrap"
import { FetchPostData } from "utils/Common_api_functions"
import Select from "react-select"
import { FaFilter } from "react-icons/fa"
import { months } from "utils/defaultpositions"
import { DatePicker } from "antd"
import { customStyles } from "utils/SelectStyles"
import AreaChart from "./AreaChart"
import CategoryProgressChart from "./ProgessBarChart"
import MarginDashboard from "./LineChart"
import TopCustomersPolarChart from "./PolarChart"
import { MdDownload } from "react-icons/md"
import Swal from "sweetalert2"
import jsPDF from "jspdf"
import html2canvas from "html2canvas"
import dayjs from "dayjs"

const { RangePicker } = DatePicker

const currentYear = new Date().getFullYear()
const years = Array.from({ length: currentYear - 2020 }, (_, i) => ({
  label: `${2021 + i}`,
  value: 2021 + i,
}))?.reverse()

const categories = [
  { id: "category1", label: "Category 1" },
  { id: "category2", label: "Category 2" },
  { id: "category3", label: "Category 3" },
  { id: "category4", label: "Category 4" },
  { id: "category5", label: "Category 5" },
]

const SuasageCategory = () => {
  const [loading, setLoading] = useState(false)
  const [sausageData, setSausageData] = useState({})
  const [top5Category, setTop5Category] = useState([])
  const [dateRange, setDateRange] = useState([])
  const [month, setMonth] = useState([])
  const [year, setYear] = useState([])

  const [sortOrderCategory, setSortOrderCategory] = useState("chronological")
  const [sortOrderGross, setSortOrderGross] = useState("chronological")
  const [sortOrderNet, setSortOrderNet] = useState("chronological")

  const [activeCategory, setActiveCategory] = useState({})

  const [currentweek, setCurrentWeek] = useState([])
  const [maxDate, setMaxDate] = useState("")

  useEffect(() => {
    const Years = secureLocalStorage?.getItem("Years")
    const Months = secureLocalStorage?.getItem("Months")
    const DateRange = secureLocalStorage?.getItem("DateRange")
    const FinalRangeRaw = secureLocalStorage?.getItem("FINALRANGE")

    setYear(Years)
    setMonth(Months)

    const activeDateRaw = DateRange ?? FinalRangeRaw
    setDateRange(activeDateRaw ? activeDateRaw.map(d => dayjs(d)) : [])
    setMaxDate(FinalRangeRaw?.[1] ? dayjs(FinalRangeRaw[1]) : null)
    setCurrentWeek(activeDateRaw ? activeDateRaw.map(d => dayjs(d)) : [])

    const fetchInitialData = async () => {
      const activeDateRange = activeDateRaw
        ? activeDateRaw.map(d => dayjs(d))
        : []

      const payload = {
        startDate: activeDateRange?.[0]?.isValid()
          ? activeDateRange[0].format("YYYY-MM-DD")
          : undefined,
        endDate: activeDateRange?.[1]?.isValid()
          ? activeDateRange[1].format("YYYY-MM-DD")
          : undefined,
        month: Months?.map(i => i?.value)?.join(",") || undefined,
        year: Years?.map(i => i?.value)?.join(",") || undefined,
      }

      const APidata = await FetchPostData(setLoading, "sheet/sausage", payload)

      if (APidata?.data?.success) {
        const sanitizeName = name => {
          if (!name) return "Other"
          const str = String(name).trim()
          return str === "1.9" || /^\d+(\.\d+)?$/.test(str) ? "Other" : str
        }

        const processedData = {
          ...APidata.data,
          revenueByCategory: (APidata.data?.revenueByCategory || []).map(
            item => ({
              ...item,
              subCategoryName: sanitizeName(item.subCategoryName),
            })
          ),
          revenueByTop5Category: (
            APidata.data?.revenueByTop5Category || []
          ).map(item => ({
            ...item,
            subCategoryName: sanitizeName(item.subCategoryName),
          })),
        }

        setSausageData(processedData)
        const categories = (processedData?.revenueByCategory || []).sort(
          (a, b) =>
            Number(b.totalNetMarginContribution) -
            Number(a.totalNetMarginContribution)
        )
        setTop5Category(categories)
        setActiveCategory(categories?.[0])
      } else {
        setSausageData({})
        setTop5Category([])
      }
    }

    fetchInitialData()
  }, [])

  const handleFilter = async () => {
    const APidata = await FetchPostData(setLoading, "sheet/sausage", {
      startDate: dateRange?.[0]?.format("YYYY-MM-DD"),
      endDate: dateRange?.[1]?.format("YYYY-MM-DD"),
      month: month?.map(item => item?.value)?.join(","),
      year: year?.map(item => item?.value)?.join(","),
    })

    if (APidata?.data?.success) {
      const sanitizeName = name => {
        if (!name) return "Other"
        const str = String(name).trim()
        return str === "1.9" || /^\d+(\.\d+)?$/.test(str) ? "Other" : str
      }

      const processedData = {
        ...APidata.data,
        revenueByCategory: (APidata.data?.revenueByCategory || []).map(
          item => ({
            ...item,
            subCategoryName: sanitizeName(item.subCategoryName),
          })
        ),
        revenueByTop5Category: (
          APidata.data?.revenueByTop5Category || []
        ).map(item => ({
          ...item,
          subCategoryName: sanitizeName(item.subCategoryName),
        })),
      }

      setSausageData(processedData)
      const categories = (processedData?.revenueByCategory || []).sort(
        (a, b) =>
          Number(b.totalNetMarginContribution) -
          Number(a.totalNetMarginContribution)
      )
      setTop5Category(categories)
      setActiveCategory(categories?.[0])
    } else {
      setSausageData({})
      setTop5Category([])
    }
  }

  const dashboardRef = useRef(null)

  const handleExport = async () => {
    const element = dashboardRef.current
    if (!element) return

    try {
      setLoading(true)

      const originalHeight = element.style.height
      const originalOverflow = element.style.overflow
      element.style.height = "auto"
      element.style.overflow = "visible"

      // ✅ Get the element's actual position on the page
      const rect = element.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const elementTop = rect.top + scrollTop // absolute top position of dashboardRef

      const canvas = await html2canvas(element, {
        scale: 1.2,
        useCORS: true,
        allowTaint: true,
        scrollX: 0,
        scrollY: -scrollTop, // ✅ This corrects the scroll offset
        y: 0, // ✅ Start capturing from top of the element itself
        x: 0,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
        logging: false,
      })

      element.style.height = originalHeight
      element.style.overflow = originalOverflow

      const imgData = canvas.toDataURL("image/jpeg", 0.75)

      const imgWidth = canvas.width / 1.2
      const imgHeight = canvas.height / 1.2

      const marginLeft = 30
      const marginRight = 30
      const marginTop = 10
      const marginBottom = 20

      const pdfWidth = imgWidth + marginLeft + marginRight
      const pdfHeight = imgHeight + marginTop + marginBottom

      const pdf = new jsPDF({
        orientation: pdfWidth > pdfHeight ? "landscape" : "portrait",
        unit: "px",
        format: [pdfWidth, pdfHeight],
        compress: true,
      })

      pdf.addImage(
        imgData,
        "JPEG",
        marginLeft,
        marginTop,
        imgWidth,
        imgHeight,
        undefined,
        "FAST"
      )

      pdf.save(
        `Dashboard_${new Date()
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-")}.pdf`
      )
    } catch (e) {
      Swal.fire({
        title: "Export Failed",
        text: "Something went wrong while exporting.",
        icon: "error",
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-content" ref={dashboardRef}>
      {loading && <Loader />}

      <div
        style={{
          background: "linear-gradient(135deg, #ffffff 0%, #f8faff 100%)",
          borderRadius: "16px",
          border: "1px solid #ede9fe",
          boxShadow: "0 4px 24px rgba(108,99,255,0.07)",
          padding: "16px 20px",
          marginBottom: "24px",
          position: "relative",
          overflow: "visible",
        }}
      >
        <div className="d-flex justify-content-between align-items-center gap-3 flex-wrap">
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div>
              <h4
                style={{
                  margin: 0,
                  fontSize: "15px",
                  fontWeight: 700,
                  color: "#000",
                }}
              >
                Sausage Category
              </h4>
              <p style={{ margin: 0, fontSize: "13px", color: "#666" }}>
                Trends by Sausage Category
              </p>
            </div>
            <div
              style={{ width: "1px", height: "36px", background: "#e2e8f0" }}
            />

            {/* Export button */}
            <Button
              onClick={handleExport}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                background: "#0f172a",
                border: "none",
                borderRadius: "10px",
                padding: "8px 16px",
                fontSize: "13px",
                fontWeight: 600,
                color: "#fff",
                cursor: "pointer",
                letterSpacing: "0.2px",
              }}
            >
              <MdDownload size={15} />
              Export
            </Button>
            {currentweek?.[0] && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  background: "#f0fdf4",
                  border: "1px solid #bbf7d0",
                  borderRadius: "10px",
                  padding: "6px 12px",
                }}
              >
                <span
                  style={{
                    width: "7px",
                    height: "7px",
                    borderRadius: "50%",
                    background: "#16a34a",
                    display: "inline-block",
                    boxShadow: "0 0 0 2px #bbf7d0",
                  }}
                />
                <div>
                  <div
                    style={{
                      fontSize: "10px",
                      color: "#15803d",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.6px",
                    }}
                  >
                    Latest week Upload
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#166534",
                      fontWeight: 600,
                      marginTop: "1px",
                    }}
                  >
                    {currentweek[0].format("DD MMM")} —{" "}
                    {currentweek[1].format("DD MMM YYYY")}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="d-flex align-items-center gap-2 flex-wrap">
            <RangePicker
              value={dateRange}
              placeholder={["Start (Sat)", "End (Fri)"]}
              onChange={setDateRange}
              format="DD-MM-YYYY"
              style={{ borderRadius: "8px", height: "38px" }}
              disabledDate={current => {
                return current && current > maxDate.endOf("day")
              }}
            />
            <Select
              isMulti
              options={months}
              value={month}
              onChange={v => {
                setMonth(v)
                if (!v || v.length === 0) {
                  setSortOrderCategory("chronological")
                  setSortOrderGross("chronological")
                  setSortOrderNet("chronological")
                }
              }}
              styles={customStyles}
              placeholder="Month"
              closeMenuOnSelect={false}
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
            <Select
              isMulti
              options={years}
              value={year}
              onChange={v => {
                setYear(v)
                if (!v || v.length === 0) {
                  setSortOrderCategory("chronological")
                  setSortOrderGross("chronological")
                  setSortOrderNet("chronological")
                }
              }}
              styles={customStyles}
              placeholder="Year"
              closeMenuOnSelect={false}
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
            <Button onClick={handleFilter} className="btn-blue rounded-2">
              <FaFilter size={12} />
            </Button>
          </div>
        </div>
      </div>

      <Card>
        <CardBody>
          <CategoryProgressChart data={top5Category} />
          <div className="d-flex  align-items-center gap-3">
            {top5Category.map((cat, index) => (
              <Button
                key={cat.id}
                onClick={() => setActiveCategory(cat)}
                className={`rounded-4 ${activeCategory?.subCategoryName === cat.subCategoryName
                  ? "btn-blue"
                  : "btn-light"
                  }`}
                style={{
                  border:
                    activeCategory?.subCategoryName === cat.subCategoryName
                      ? "1px solid #0d6efd"
                      : "1px solid #dee2e6",
                  fontWeight:
                    activeCategory?.subCategoryName === cat.subCategoryName
                      ? 600
                      : 500,
                }}
              >
                {cat.subCategoryName}
              </Button>
            ))}
          </div>
          <div className="">
            <AreaChart
              category={sausageData?.revenueByTop5Category?.find(
                item =>
                  item?.subCategoryName === activeCategory?.subCategoryName
              )}
              sortOrder={sortOrderCategory}
              onSortOrderChange={setSortOrderCategory}
            />
          </div>
          {/* <div className="d-flex align-items-center justify-content-end gap-3 mt-3">
            <Select></Select>
            <Select></Select>
          </div> */}
          <div className="mt-3">
            <MarginDashboard
              data={sausageData}
              sortOrderGross={sortOrderGross}
              setSortOrderGross={setSortOrderGross}
              sortOrderNet={sortOrderNet}
              setSortOrderNet={setSortOrderNet}
            />
          </div>
          <div className="mt-3">
            <TopCustomersPolarChart data={sausageData?.top5customers} />
          </div>
        </CardBody>
      </Card>
    </div>
  )
}

export default SuasageCategory
